const excludeArr = process.env.VUE_APP_EXCLUDE_CONST?.split(' ');

export default (e, mapObj, itemValue = (i) => i.id) => {
  const prefix = Object.keys(mapObj)?.[0];
  if (!excludeArr?.length || !prefix) return true;

  return !excludeArr.some((excludeItem) => mapObj[prefix][excludeItem.replace(`${prefix}-`, '')] === itemValue(e));
};
